import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useAuth } from '../context/AuthContext';
import Navbar from './Navbar';
import Footer from './Footer';
import TopBar from './TopBar';
import './Register.css';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const redirect = params.get('redirect');
  const safeRedirect = redirect && redirect.startsWith('/') ? redirect : null;

  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);

    try {
      const result = await login(formData);

      if (result.success) {
        toast.success('Login successful!');
        if (safeRedirect) {
          navigate(safeRedirect, { replace: true });
          return;
        }
        // Redirect based on user role
        const userRole = (result.user?.role || result.user?.accountType || '').toLowerCase();
        if (userRole === 'admin') {
          navigate('/admin/lms');
        } else {
          navigate('/student/dashboard');
        }
      } else {
        toast.error(result.error || 'Login failed');
      }
    } catch (err) {
      toast.error('An unexpected error occurred');
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <TopBar />
      <main className="page-auth">
        <div className="container">
          <Navbar />
          <div className="row">
            <div className="col-lg-10 offset-lg-1">
              <section className="auth-wrapper">
                <div className="row">
                  <div className="col-md-6 mb-4 mb-md-0">
                    <h2 className="auth-section-title">Log In</h2>
                    <p className="auth-section-subtitle">Access your account</p>

                    <form onSubmit={handleSubmit} className="auth-form" noValidate>
                      <div className="form-group mb-2">
                        <label htmlFor="email">Email</label>
                        <input
                          type="email"
                          className="form-control form-control-sm"
                          id="email"
                          name="email"
                          placeholder="Enter email"
                          value={formData.email}
                          onChange={handleChange}
                          required
                          disabled={loading}
                        />
                      </div>
                      <div className="form-group mb-2">
                        <label htmlFor="password">Password</label>
                        <input
                          type="password"
                          className="form-control form-control-sm"
                          id="password"
                          name="password"
                          placeholder="Enter password"
                          value={formData.password}
                          onChange={handleChange}
                          required
                          disabled={loading}
                        />
                      </div>

                      <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="keepLogin"
                            disabled={loading}
                          />
                          <label className="form-check-label" htmlFor="keepLogin">
                            Keep me logged in
                          </label>
                        </div>
                        <a href="#!" className="forgot-password-link">
                          Forgot password?
                        </a>
                      </div>

                      <button
                        className="btn btn-sm btn-primary btn-auth-submit"
                        type="submit"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Logging in...
                          </>
                        ) : (
                          'Log In'
                        )}
                      </button>
                    </form>

                    <p className="mt-3 mb-0">
                      <Link
                        to={safeRedirect ? `/register?redirect=${encodeURIComponent(safeRedirect)}` : '/register'}
                        className="text-dark font-weight-bold"
                      >
                        New User? Sign Up
                      </Link>
                    </p>
                  </div>
                  <div className="col-md-6 d-flex align-items-center">
                    <img src="assets/images/login.png" alt="login" className="img-fluid" />
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default Login;
